import { Linear, Sine, TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "../../Application";
import * as Constants from "../../Data/Constants";
import * as SFX from "../../Data/SoundEffectKeys";
import { AnimatedObstacle } from "../../GameObjects/Obstacles/AnimatedObstacle";
import { BoxCollider } from "../../Physics/BoxCollider";

export class Boomerang extends AnimatedObstacle {
    private static readonly SPEED: number = -200;
    private static readonly SPEED_REV: number = -(Constants.PARALLAX_SPEED + Boomerang.SPEED * 2.0);
    private static readonly Y_RANGE: PIXI.Point = new PIXI.Point(-350, 50);
    private static readonly REVERSE_THRESHHOLD: number = -425;

    private _isReversed: boolean;
    private _loopSfxID: any;

    private _speedTween: TimelineLite | undefined;

    constructor() {
        super(
            new HLF.SpriteAnimation(
                "boomerang-", Constants.SPRITESHEET_OBSTACLE_PREFIX + "00", 8, 2,
                12, true,
            ),
            Boomerang.SPEED,
            new BoxCollider(15, 130, -30, 30),
        );
        this._isReversed = false;
        this._collisionSfx = SFX.IMPACT_BOOMERANG;

        this.position.y = HLF.Random.floatBetweenPoint(Boomerang.Y_RANGE);

        Application.instance.audio.load(SFX.BOOMERANG_LOOP, HLF.AudioCategory.SFX);
        const sfx: HLF.IAudioTrack = Application.instance.audio.getAudioTrack(
            SFX.BOOMERANG_LOOP, HLF.AudioCategory.SFX,
        )!;
        sfx.setLooped(true);
        sfx.setVolume(0.5);
        this._loopSfxID = (sfx as HLF.HowlerTrack).getSource().play();
    }

    public get isReversed(): boolean {
        return this._isReversed;
    }

    private get speed(): number {
        return this._speed;
    }

    private set speed(pValue: number) {
        this._speed = pValue;
    }

    public update(pDeltaTime: number): void {
        super.update(pDeltaTime);

        if (this._isReversed === false && this.position.x < Boomerang.REVERSE_THRESHHOLD) {
            this.reverse();
        }
    }

    public cleanup(): void {
        this.stopLoopSfx();
        super.cleanup();
    }

    public destroy(pOptions: boolean | PIXI.DestroyOptions = { children: true }): void {
        if (this._speedTween !== undefined) { this._speedTween.kill(); }
        super.destroy(pOptions);
    }

    public onCollision(pIsBalloonInvuln: boolean): void {
        super.onCollision(pIsBalloonInvuln);
        if (pIsBalloonInvuln) {
            this.playDeflectAnim();
            this.stopLoopSfx();
            this._anim.holdFrame(Boomerang.ANIM_KEY, 1);
        }
    }

    private reverse(): void {
        this._isReversed = true;
        this._speedTween = new TimelineLite();
        this._speedTween.to(this, 1.0, {
            speed: 0,
            ease: Linear.easeNone,
        });
        this._speedTween.call(() => {
            this.active = false;

            const sfx: HLF.HowlerTrack = Application.instance.audio.getAudioTrack(
                SFX.BOOMERANG_LOOP, HLF.AudioCategory.SFX,
            )! as HLF.HowlerTrack;
            sfx.getSource().fade(sfx.getSource().volume(), 0, 1500, this._loopSfxID);
        });
        this._speedTween.to(this, 1.5, {
            speed: Boomerang.SPEED_REV,
            ease: Linear.easeNone,
        });
        this._speedTween.to(this.scale, 2.5, {
            x: 0.7,
            y: 0.7,
        }, 0);
    }

    private stopLoopSfx(): void {
        const sfx: HLF.IAudioTrack = Application.instance.audio.getAudioTrack(
            SFX.BOOMERANG_LOOP, HLF.AudioCategory.SFX,
        )!;
        (sfx as HLF.HowlerTrack).getSource().stop(this._loopSfxID);
    }
}
